import Q from 'q';

import type { ActionContext } from 'js/lib/ActionContext';

import VerificationStoreClass from 'bundles/in-course-stores/stores/VerificationStore';
import verificationDisplayPromise from 'bundles/verificationDisplay/promises/verificationDisplay';

/**
 * @param {Fluxible.ActionContext} actionContext
 * @return {Promise}
 */
export const loadVerificationDisplay = (
  actionContext: ActionContext,
  {
    authenticated,
    userId,
    courseId,
    s12nId,
    isCourseVerificationEnabled,
  }: {
    authenticated: boolean;
    userId: string;
    courseId: string;
    s12nId?: string;
    isCourseVerificationEnabled: boolean;
  }
): Q.Promise<any> => {
  if (actionContext.getStore(VerificationStoreClass).hasLoaded()) {
    return Q();
  }

  if (authenticated) {
    return verificationDisplayPromise(userId, courseId, isCourseVerificationEnabled, s12nId).then(
      (rawVerificationDisplay: $TSFixMe) => {
        actionContext.dispatch('LOAD_VERIFICATION_DISPLAY', rawVerificationDisplay);
      }
    );
  } else {
    actionContext.dispatch('LOAD_VERIFICATION_DISPLAY', null);
    return Q();
  }
};
